export enum Tags {
  Pacer = 'P',
  Wrong = 'W',
  Training = 'T',
  Injury = 'I',
}
